import React from 'react';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import intl from 'react-intl-universal';

import DisneyPlusLogo from 'images/Disney-plus-logo-1.png';
import YaleLogo from 'images/Yale.png';
import ToyotaLogo from 'images/Toyota.png';
import SalvationArmyLogo from 'images/salvation-army-logo.png';
import LaMetroLogo from 'images/LaMetro.png';
import SalvatoreFerragamoLogo from 'images/SalvatoreFerragamo.png';
import TwitterLogo from 'images/Twitter.png';
import PaulanerLogo from 'images/paulaner-logo.png';
import AtlassianLogo from 'images/Atlassian.png';
import NasaLogo from 'images/Nasa.png';

const useStyles = makeStyles(() => ({
  section: {
    margin: '2.5rem auto',
    maxWidth: 1180
  },
  heading: {
    maxWidth: '785px',
    color: '#201727',
    fontWeight: 600,
    fontSize: '40px',
    lineHeight: '52px',
    margin: '0 auto 3rem',
    textAlign: 'center'
  },
  companyLogoContainer: {
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  disneyLogo: {
    width: 155,
    height: 85
  },
  yaleLogo: {
    width: 156,
    height: 78
  },
  toyotaLogo: {
    width: 145,
    height: 72
  },
  salvationArmyLogo: {
    width: 152,
    height: 76
  },
  laMetroLogo: {
    width: 163,
    height: 73
  },
  salvatoreFerragamoLogo: {
    width: 177,
    height: 88
  },
  twitterLogo: {
    width: 90,
    height: 75
  },
  paulanerLogo: {
    width: 79,
    height: 79
  },
  atlassianLogo: {
    width: 146,
    height: 73
  },
  nasaLogo: {
    width: 153,
    height: 77
  }
}));

export default function OurCustomersSection() {
  const classes = useStyles();
  return (
    <section className={classes.section}>
      <h2 className={classes.heading}>{intl.get('components.OurCustomersSection.heading')}</h2>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mb={5} mx={4}>
        <div className={classes.companyLogoContainer}>
          <img className={classes.disneyLogo} alt="disney-plus-logo" src={DisneyPlusLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.yaleLogo} alt="yale-logo" src={YaleLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.toyotaLogo} alt="toyota-logo" src={ToyotaLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.salvationArmyLogo} alt="salvation-army-logo" src={SalvationArmyLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.laMetroLogo} alt="la-metro-logo" src={LaMetroLogo}></img>
        </div>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mx={4}>
        <div className={classes.companyLogoContainer}>
          <img className={classes.salvatoreFerragamoLogo} alt="salvatore-ferragamo-logo" src={SalvatoreFerragamoLogo} />
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.twitterLogo} alt="twitter-logo" src={TwitterLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.paulanerLogo} alt="paulaner-logo" src={PaulanerLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.atlassianLogo} alt="atlassian-logo" src={AtlassianLogo}></img>
        </div>
        <div className={classes.companyLogoContainer}>
          <img className={classes.nasaLogo} alt="nasa-logo" src={NasaLogo}></img>
        </div>
      </Box>
    </section>
  );
}
